import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'

export enum ConfigurationAutomationPersonnelEntitiesAssociationModalTabIndex {
    BASIC = 0,
    TOPOGRAPHIC_CODE_ASSIGNMENT = 1,
    DEPARTMENT_TYPE_ASSIGNMENT = 2,
    MOST_LIKELY_MORPHOLOGIC_CODE_ASSIGNMENT = 3,
    NUMBER_ASSIGNMENT = 4,
    PROCEDURE__ASSIGNMENT = 5,
    SAMPLE_TYPE_ASSIGNMENT = 6,
    WEEKDAY_ASSIGNMENT = 7
}

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalState {
    personnel: ConfigurationPersonnelResponse | null
    activeTabIndex: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalState => ({
        personnel: null,
        activeTabIndex: ConfigurationAutomationPersonnelEntitiesAssociationModalTabIndex.BASIC
    })
